export enum JournalingRoutes {
  HISTORY = 'journalingHistory',
  NEW_ENTRY = 'journalingNewEntry',
}
